import React, { useEffect, useState } from "react";
import { Table, Input } from "antd";
import { Helmet } from "react-helmet";
import startCase from "lodash/startCase";
import { Typography } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import RequirePermission from "../components/Common/RequirePermission";
const { Title } = Typography;

const Cities = () => {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterText, setFilterText] = useState("");

  const handleSearch = (e) => {
    const value = e.target.value;
    setFilterText(value);
    setCurrentPage(1);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    // if (typeof sorter.order === "undefined") {
    //   setSortingOrder("desc");
    //   setSortingColumn("id");
    // } else {
    //   setSortingColumn(sorter.field);
    //   setSortingOrder(sorter.order === "ascend" ? "asc" : "desc");
    // }
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + `/api/cities`,
        {
          params: {
            filter: filterText, // add filter if needed
            limit: pageSize,
            page: currentPage,
          },
        }
      );
      let records = response.data.data.data;
      setTotalRecords(response.data.data.total);
      setCities(records);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching cities data", error);
    }
  };

  useEffect(() => {
    const fetchTimer = setTimeout(() => {
      fetchData();
    }, 500);

    return () => clearTimeout(fetchTimer);
  }, [currentPage, pageSize, filterText]);

  const columns = [
    { title: "Name", dataIndex: "name" },
    {
      title: "Updated At",
      dataIndex: "updated_at",
      render: (text) => (
        <span className="text-small">
          {dayjs(text).format("DD-MM-YYYY HH:mm")}
        </span>
      ),
    },
    {
      title: "Updated By",
      dataIndex: "updated_by_user",
      render: (text) => {
        return <span className="text-small">{startCase(text)}</span>;
      },
    },
  ];

  return (
    <RequirePermission permission="cities.view">
      <div style={{ padding: "1rem" }}>
        <Helmet>
          <title>{`${process.env.REACT_APP_NAME} | Cities`}</title>
        </Helmet>
        <Title level={3} style={{ marginBottom: "1rem" }}>
          Cities
        </Title>
        <div className="d-flex justify-content-between mb-3">
          <Input.Search
            placeholder="Search city"
            value={filterText}
            onChange={handleSearch}
            style={{ width: 200 }}
          />
        </div>

        <Table
          loading={loading}
          columns={columns}
          dataSource={cities}
          scroll={{ x: "max-content" }}
          rowKey={(record) => record.id}
          onChange={handleTableChange}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalRecords,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} cities`,
            showSizeChanger: true, // Enables the page size selection dropdown
            pageSizeOptions: ["5", "10", "20", "50", "100"], // Options for the page size selection
          }}
        />
      </div>
    </RequirePermission>
  );
};

export default Cities;
